export default Object.freeze({
  Unset: 0,
  RechazoServicios: 1,
  TrasladadoOtraCorporacion: 2,
  TrasladoInterno: 3,
  LogrosProgresoSignificativoMetasObjetivosTrazados: 4,
  Ausentismo: 6,
  EgresoAjuste: 8,
  EgresoGraduacion: 9,
  EgresoFallecimiento: 10,
  EjecucionFuncional: 14,
  BeneficioOptimoServicios: 15,
  BajaExpectativaCambiosFuncionamiento: 16,
  TrasladadoCorporacionSolicitudPadre: 18,
  TrasladadoOtraEscuela: 19,
});
